import React from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {hashes} from "constants/tabs.const";

const SignContractInviteLink = ({addClass}) => {
  const {t} = useTranslation();

  return (
    <div className={`df-row-center fz-13${addClass ? ` ${addClass}` : ""}`}>
      <div className="discrete-text mr-1">
        {t("SIGN_CONTRACT_DATA_SIGNING_PARTIES_INVITE_SIGNATORY_DESCRIPTION")}
      </div>
      <Link to={hashes.INVITE_USERS}>
        {t("SIGN_CONTRACT_DATA_SIGNING_PARTIES_INVITE_SIGNATORY_LINK")}
      </Link>
    </div>
  );
};

export default SignContractInviteLink;
